import React, { SVGProps } from 'react';

const DefaultStringIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg height="20" width="20" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M4.15674 6.35288H7.59567" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path
        d="M2.50125 10.0002C2.4954 12.1371 3.4034 14.1745 4.99635 15.5988C6.5893 17.0231 8.7152 17.6984 10.8381 17.4545"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M9.17065 2.54597C11.2935 2.30201 13.4194 2.97732 15.0124 4.40163C16.6053 5.82594 17.5133 7.86335 17.5075 10.0002"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="M5.99637 2.91394L3.54346 7.49918" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M8.12867 7.49918L5.99634 2.91394" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M13.3392 16.6697V11.6676" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25" />
      <path
        d="M13.3391 16.6696H15.8602C16.5398 16.6696 17.0907 16.1187 17.0907 15.4391V15.4391C17.0907 14.7595 16.5398 14.2086 15.8602 14.2086H13.3391"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M13.3391 11.6676H15.5489C16.2506 11.6676 16.8194 12.2364 16.8194 12.9381V12.9381C16.8194 13.6398 16.2506 14.2087 15.5489 14.2087H13.3391"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default DefaultStringIcon;
